import { defineStore } from "pinia";
import { jwtTokenOpenApiResolver } from "@two-ui/auth0";
import store from "./store";
import { FeatureFlaggedCurrencies } from "@two-ui/constants";
import { Region, UserOnboardingState } from "./types";

export const useGlobalStore = defineStore("globalStore", {
  state: () => ({
    customerDefaultCurrency: "$",
    token: jwtTokenOpenApiResolver,
    customerName: null as string | null,
    customerId: null as string | null,
    userName: null as string | null,
    useBalancesTncAccepted: null as boolean | null,
    customerContactEmail: null as string | null,
    brandApprovalAccessToken: null as string | null,
    customerFeatureFlags: null as {
      allowManualBrandApproval: boolean;
      floats: boolean;
      cardFees: boolean;
      fx: boolean;
      breakage: boolean;
      discounts: boolean;
      enableFraudBlocking: boolean;
    } | null,
    useNewKYBForm: null as boolean | null,
    customerSource: null as string | null,
    userPermissions: null as Array<string> | null,
    currencyToggles: null as Record<FeatureFlaggedCurrencies, boolean> | null,
    enableTransactionCsvDownload: null as boolean | null,
    shouldPreselectBannerOrderData: false as boolean,
    displayPromotionalBanner: false as boolean,
    region: Region.Default,
    enableTopUpInvoices: null as boolean | null,
    enableLowBalanceBadges: null as boolean | null,
    asyncTrade: null as boolean | null,
    timezoneOverride: null as string | null,
    promoBannerClicked: false as boolean,
    playgroundMode: false as boolean,
    userOnboardingState: null as UserOnboardingState | null,
    enableCustomerDefaultCurrency: true as boolean,
    useRequestMerchantAccessBanner: true as boolean,
    shopCountry: null as string | null,
  }),
  actions: {
    clearTimezoneOverride() {
      this.timezoneOverride = null;
    },

    isCustomerAllowedManualBrandApproval(): boolean {
      if (
        !this.customerFeatureFlags ||
        this.customerFeatureFlags.allowManualBrandApproval === undefined ||
        this.customerFeatureFlags.allowManualBrandApproval === null
      ) {
        return true;
      }
      return this.customerFeatureFlags.allowManualBrandApproval;
    },

    setTimezoneOverride(timezone: string) {
      this.timezoneOverride = timezone;
    },

    openLink(tagIdentifier: string) {
      if (store.shouldShowNewTag(tagIdentifier)) {
        store.hideNewTag(tagIdentifier);
      }
    },

    setDisplayPromotionalBanner(dislayBanner: boolean) {
      this.displayPromotionalBanner = dislayBanner;
    },
    setGeolocation(region: Region) {
      this.region = region;
    },
  },
});
